import React from 'react'
import Link from 'gatsby-link'

import '../styles/blog-listing.css'

export default function Index({ data }) {
  const { edges: posts } = data.allMarkdownRemark
  return (
    <div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          flexWrap: 'wrap',
          width: '100%',
          height: '100vh%',
          minHeight: '500px',
          justifyContent: 'center',
          // alignItems: 'center'
        }}
      >
        <h1 className={'intro-title'}>Hi there, my name is Stevica.</h1>
        <p className={'intro-description'}>
          I’m a developer based in Novi Sad.
          Welcome to my website, where you can find out more about me, my skills and my interests.

        </p>
        <div>
          <a className={'intro-about-link'} href="/about">
            About me
          </a>
        </div>
      </div>

      <div className="blog-posts">
        {posts
          .filter(post => post.node.frontmatter.title.length > 0)
          .map(({ node: post }) => {
            return (
              <div className="blog-post-preview" key={post.id}>
                <h2>
                  <Link className={'list-item'} to={post.frontmatter.path}>
                    {post.frontmatter.title}
                  </Link>
                </h2>
                <p className={'date'}>{post.frontmatter.date}</p>
                <p>
                  <i>{post.excerpt}</i>
                </p>
              </div>
            )
          })}
      </div>
    </div>
  )
}

export const pageQuery = graphql`
  query IndexQuery {
    allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          excerpt(pruneLength: 250)
          id
          frontmatter {
            title
            date(formatString: "MMMM DD, YYYY")
            path
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js